import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-promo-link',
    templateUrl: './promo-link.component.html',
    styleUrls: ['./promo-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PromoLinkComponent {
  @Input() linkText: string = '';
  @Input() href: string = '';
  @Input() routerUrl: string;
  @Input() openInNewTab: boolean = false;

}
